<template>
    <div v-if="needGoogleLogin">
            <form class="login-form login-form-google">
                <div class="form-group m-b-0">
                    <button type="button" class="btn btn-block btn-lg btn-red" @click="googleLogin()">
                        <i class="icon-gplus"></i>
                        <span>SIGN IN USING DELHIVERY ID</span>
                    </button>
                </div>
            </form>
    </div>
</template>

<script>
import umsinit from './../mixins/umsinit';
export default {

  name: 'GoogleLogin',
  props: [ 'needGoogleLogin'],
  methods: {

      googleLogin(){
         
        this.$emit('googleLogin', true);
      }
      
  }

}
</script>


// WEBPACK FOOTER //
// src/components/GoogleLogin.vue